import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { TOAST_LOADING } from './peticion-api.interceptor';
import { inject } from '@angular/core';
import { ToastService } from 'ng-components-tsi';
import { EMPTY, finalize } from 'rxjs';

/** Texto que se muestra en el toast: "Cargando <descri>". */
export const API_DESC = new HttpContextToken(() => 'DESCONOCIDO');

let _activeRequestReports = new Set<string>();

export const peticionApiReportsInterceptor: HttpInterceptorFn = (req, next) => {

  const useToast = req.context.get(TOAST_LOADING);
  const descri = req.context.get(API_DESC);

  if (!useToast) {
    return next(req)
  }

  const key = req.method + req.urlWithParams + JSON.stringify(req.body ?? {});
  if (_activeRequestReports.has(key)) {
    return EMPTY;
  }
  _activeRequestReports.add(key);

  const toast = inject(ToastService)
  let toastId: number | null = null;

  if (useToast) {
    toastId = toast.showLoading(`Cargando ${descri || 'download_file'}`)
  }

  return next(req).pipe(finalize(() => {
    if (useToast && toastId != null) {
      _activeRequestReports.delete(key);
      toast.updateProgress(toastId, 100)
      toast.remove(toastId)
    }
  }))
}
